<template>
  <div class="page-card">
    <div class="page-card_head">
      <slot name="header"/>
    </div>
    <div class="page-card_body">
      <slot name="body"/>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
  },
};
</script>
<style scoped lang="scss">
.page-card{
  background:#fff;
  border-radius: 4px;
  .page-card_head{
    padding:0.24rem 0.32rem;
    border-bottom:1px solid #F0F0F0;
    font-size: 0.22rem;
    font-weight: bold;
  }
  .page-card_body{
    padding:0.24rem 0.32rem;
  }
}

</style>
